module.exports = __webpack_public_path__ + "media/KZ-ALM.44d603b7.ogg";